(function(){
  // Read product data
  const el = document.querySelector('script[data-product-json]');
  if (!el) return;
  const data = JSON.parse(el.textContent);
  const product = data.product;

  // Selectors (match your markup)
  const optionSelects = Array.from(document.querySelectorAll('.options-selection__input-select'));

// --- handle products with no visible option selects (single-variant/simple products)
if (optionSelects.length === 0) {
  // Resolve current/first available variant
  let v = null;
  const idFromForm = idSelect && idSelect.value;
  if (idFromForm) {
    v = product.variants.find(x => String(x.id) === String(idFromForm)) || null;
  }
  if (!v) {
    v = product.variants.find(x => x.available) || product.variants[0] || null;
  }

  // If we found a variant, reflect proper state and exit (no listeners needed)
  if (v) {
    updateId(v);
    updatePrice(v);
    updateButton(v);
    updateURL(v);
  }
  return; // prevent setting "Unavailable" on simple products
}


  const form = document.querySelector('form[action^="/cart/add"]');
  if (!form) return;
  const idSelect = form.querySelector('select[name="id"]');
  const btn = form.querySelector('[type="submit"], button[name="add"]');

  // Price elements (use what's available)
  const priceEl = document.querySelector('[data-product-price] .money, [data-product-price], .product__price .money, .product__price');
  const compareEl = document.querySelector('[data-compare-price] .money, [data-compare-price], .product__price--compare .money, .product__price--compare');

  const moneyFormat = (window.Shopify && Shopify.money_format) || '${{amount}}';
function fmt(cents) {
  const number = cents / 100;

  // Format with commas & decimals
  const formatted = number.toLocaleString('en-AU', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  });

  // Inject into Shopify's money format (e.g. "${{amount}}")
  return moneyFormat
    .replace('{{amount}}', formatted)
    .replace('{{ amount }}', formatted);
}

  function selectedOptions(){
    // Map selects by index 0..n in the same order as product.options
    return product.options.map((_, i) => optionSelects[i]?.value ?? null);
  }

  function findVariant(vals){
    return product.variants.find(v => v.options.every((val,i)=>val===vals[i])) || null;
  }

function updatePrice(v){
  if (!v) return;

  // MAIN PRICE ELEMENTS
  const priceContainer = document.querySelector('[data-price-container]');
  const priceEl = document.querySelector('[data-price]');
  const compareContainer = document.querySelector('[data-price-compare-container]');
  const compareEl = document.querySelector('[data-price-compare]');
  
  // SALE BADGE
  const badge = document.querySelector('[data-badge-sales]');
  const badgeSaved = document.querySelector('[data-price-money-saved]');

  // Format helper
  const money = c => moneyFormat.replace('{{amount}}', (c/100).toFixed(2));

  // --- CURRENT PRICE ---
  if (priceEl) {
    priceEl.textContent = money(v.price);
  }

  // --- COMPARE PRICE ---
  if (v.compare_at_price > v.price) {
    // Show compare-at container
    if (compareContainer) compareContainer.classList.add('visible');
    if (compareEl) compareEl.textContent = money(v.compare_at_price);

    // Calculate & show savings
    if (badge) badge.style.display = '';
    if (badgeSaved) badgeSaved.textContent = money(v.compare_at_price - v.price);

    // Ensure current price has sale class
    if (priceContainer) priceContainer.classList.add('price__current--on-sale');

  } else {
    // Hide compare price
    if (compareContainer) compareContainer.classList.remove('visible');
    if (compareEl) compareEl.textContent = '';

    // Hide badge
    if (badge) badge.style.display = 'none';

    // Remove sale class from current price
    if (priceContainer) priceContainer.classList.remove('price__current--on-sale');
  }
}


  function updateButton(v){
    if (!btn) return;
    if (!v) {
      btn.disabled = true;
      btn.classList.add('disabled');
      btn.textContent = 'Unavailable';
      return;
    }
    const available = !!v.available;
    btn.disabled = !available;
    btn.classList.toggle('disabled', !available);
    btn.textContent = available ? 'Add to cart' : 'Sold out';
  }

  function updateId(v){
    if (idSelect && v) {
      idSelect.value = String(v.id);
      // notify any listeners depending on id change
      idSelect.dispatchEvent(new Event('change', { bubbles:true }));
    }
  }

  function updateURL(v){
    if (!v) return;
    const url = new URL(window.location.href);
    url.searchParams.set('variant', v.id);
    window.history.replaceState({}, '', url.toString());
  }

function updateImage(v) {
  // If variant has no featured media, do nothing (fallback)
  if (!v || !v.featured_media || !v.featured_media.id) return;

  const mediaId = v.featured_media.id;

  // Find the slide matching this media ID
  const slide = document.querySelector(
    `.product-gallery__viewer .swiper-slide[data-media-id="${mediaId}"]`
  );
  if (!slide) return; // do nothing if slide not found

  // Get the Swiper instance
  const viewer = document.querySelector('.product-gallery__viewer.swiper-initialized');
  if (!viewer || !viewer.swiper) return; // do nothing if Swiper not ready

  const index = Array.from(viewer.querySelectorAll('.swiper-slide')).indexOf(slide);
  if (index >= 0) {
    viewer.swiper.slideTo(index);
  }
}


  function onChange(){
    const v = findVariant(selectedOptions());
    updateId(v);
    updatePrice(v);
    updateButton(v);
    updateURL(v);
    updateImage(v);

    // Update SKU
    const skuEl = document.querySelector('[data-product-sku]');
    if (skuEl) {
      skuEl.textContent = v && v.sku ? v.sku : '';
    }
  }

  optionSelects.forEach(s => s.addEventListener('change', onChange));
  onChange(); // initialise
})();
